import React, { useContext, useState } from 'react'
import { ResponsiveContext } from '../../utils/context/ResponsiveContext'
import Button from '../button/Button'
import { FormattedMessage } from 'react-intl'
import { WHITE } from '../../theme'
import linksEnum from '../../enums/linksEnum'
import { makeStyles } from 'tss-react/mui'
import { useLocation } from 'react-router-dom'

const useStyles = makeStyles<{ isLargeScreen: boolean, pathname: string }>()(
	(theme, { isLargeScreen, pathname }) => ({
		texteContainer: {
			position: 'relative',
			paddingBottom: isLargeScreen ? 0 : 30
		},
		lirePlus: {
			border: '1px solid #D0D5DA',
			borderRadius: 25,
			position: 'absolute',
			bottom: pathname.includes(linksEnum.OFFRE) ? -30 : 0,
			left: pathname.includes(linksEnum.OFFRE) ? 0 : '50%',
			transform: pathname.includes(linksEnum.OFFRE) ? 'unset' : 'translate(-50%, 0)'
		},
		opacite: {
			width: '100%',
			height: 50,
			position: 'absolute',
			bottom: 0,
			left: 0,
			background: WHITE,
			opacity: 0.8
		}
	})
)

interface AcceptingProps {
	texte: string,
	texteStyle: string,
	caracteresATronquer: number
}

type TronquageTexteProps = AcceptingProps

const TronquageTexte: React.FC<TronquageTexteProps> = (
	{
		texte,
		texteStyle,
		caracteresATronquer
	}
) => {
	const { isLargeScreen } = useContext(ResponsiveContext)
	const location = useLocation()
	const { classes } = useStyles({ isLargeScreen, pathname: location.pathname })
	// Vérification de si le JS est activé ou non
	const [lirePlus, setLirePlus] = useState<boolean>(typeof window === 'undefined')

	const texteTronquee = () => {
		// On ne formatte pas le texte s'il n'y a pas de caractères à tronquer
		if (caracteresATronquer === 0) {
			return texte
		}

		// Si le texte fait moins de X caractères inclus, on renvoie directement le texte
		if (texte.length <= caracteresATronquer) {
			return texte
		}

		// Sinon, on check si l'utilisateur a demandé à voir plus de texte, auquel cas on renvoie tout le texte
		if (lirePlus) {
			return texte
		}

		return texte.substring(0, caracteresATronquer)
	}

	return (
		<div className={classes.texteContainer}>
			<p className={texteStyle}>{texte && texteTronquee()}</p>

			{
				caracteresATronquer > 0 && !lirePlus && texte && texte.length > caracteresATronquer && (
					<>
						{/* Bloc permettant de rajouter un effet de flou sur la dernière ligne */}
						<div className={classes.opacite}></div>

						<Button
							background="backgroundWhite"
							color={isLargeScreen ? 'colorAccessibility' : location.pathname.includes(linksEnum.OFFRE) ? 'colorBlue' : 'colorAccessibility'}
							textStyle="text4"
							buttonStyle={classes.lirePlus}
							onClick={() => setLirePlus(true)}
						>
							<FormattedMessage
								id="tronquageTexte.lirePlus"
								defaultMessage="Lire plus +"
								description="Bouton lire plus"
							/>
						</Button>
					</>
				)
			}
		</div>
	)
}

export default TronquageTexte